module.exports = __webpack_public_path__ + "img/暂无.9c9e45fe.png";